import React, { useEffect, useState, Suspense } from "react";
import { fetchProductOverview } from "./client";

const RotatingLines = React.lazy(() =>
  import("react-loader-spinner").then((module) => ({
    default: module.RotatingLines,
  }))
);

const ProductOverview = ({ handle }) => {
  const [loading, setLoading] = useState(false);
  const [overview, setOverview] = useState([]);

  async function getTags(slug) {
    setLoading(true);
    const response = await fetchProductOverview(slug);
    setOverview(response || []);
    setLoading(false);
  }

  useEffect(() => {
    getTags(handle);
  }, [handle]);
  return (
    <div className="flex flex-wrap items-center mb-5 gap-[14px]">
      {loading && (
        <Suspense fallback={<div>Loading...</div>}>
          <RotatingLines
            strokeColor="#e85b35"
            strokeWidth="4"
            animationDuration="0.85"
            width="40"
            visible={true}
          />
        </Suspense>
      )}
      {overview && overview && (
        <p className="text-sm leading-6 max-w-[450px] my-5 font-medium">
          {overview}
        </p>
      )}
    </div>
  );
};

export default ProductOverview;
